import { Box } from '@mui/material';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import { WEEKLY_BASIS_TARGET_ANSWERS, WeeklyBasisTarget } from '../../../providers/QuizProvider/QuizProvider.types';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import QuizContainer from '../../common/QuizContainer';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step6() {
  const { setStep, setQuizData } = useQuizState();
  const handleClick = (type: WeeklyBasisTarget) => {
    setQuizData((prev) => ({
      ...prev,
      weeklyTarget: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={6}
        stepsNumber={19}
      ></QuizHeader>
      <QuizQuestion text="On a weekly basis, what is your drinking target?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(WEEKLY_BASIS_TARGET_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof WEEKLY_BASIS_TARGET_ANSWERS)}
              variant={ButtonType.WHITE}
              text={WEEKLY_BASIS_TARGET_ANSWERS[key as keyof typeof WEEKLY_BASIS_TARGET_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step6;
